import axiosInstance from '@/plugins/axios'
import treeUtils from '@/utils/treeUtils'
import { encrypt } from '@/utils/encryt'
export const SYSTEM_API_LOGIN = '/mockApi/login'
export const SYSTEM_API_DO_REFRESHTOKEN = '/mockApi/refreshToken'
export const SYSTEM_API_GET_AUTH = '/mockApi/getAuth'

export const login = async ({ username, password, code, codeId }) => {
  if (process.env.VUE_APP_USE_MOCK === 'true') {
    const res = await axiosInstance.post(SYSTEM_API_LOGIN, { username, password, code })
    return res.data
  }
  const res = await axiosInstance.post('/user/admin/auth/login', {
    account: username,
    password: encrypt(password),
    code,
    codeId,
  })
  return res.data
}

export const doRefreshToken = async ({ refreshToken }) => {
  if (process.env.VUE_APP_USE_MOCK === 'true') {
    const res = await axiosInstance.post(SYSTEM_API_DO_REFRESHTOKEN, { refreshToken })
    return res.data
  }
}

export const getInfo = async () => {
  if (process.env.VUE_APP_USE_MOCK === 'true') {
    const res = await axiosInstance.post(SYSTEM_API_GET_AUTH)
    const menus = res.data
    return {
      roles: {
        permissions: {
          menus,
        },
      },
    }
  }
  // 后台不管理icon，这里直接通过title映射管理
  const titleIconMap = {
    系统设置: 'icon-shezhi',
    首页: 'icon-shouye',
    数据看板: 'icon-yunying',
    用户管理: 'icon-qiyeguanli',
    供应商审核: 'icon-gongyingshangshenhe',
    供应商管理: 'icon-qiyeliebiao',
    用户列表: 'icon-qiyeyuangongliebiao',
    产品管理: 'icon-chanpinguanli',
    签证产品: 'icon-zhuandan',
    制签产品: 'icon-zhiqian',
    公证产品: 'icon-gongzheng',
    认证产品: 'icon-mobanguanli',
    保险产品: 'icon-_baoxiandingdan',
    日本送签社: 'icon-lvhangshe1',
    日本身元记录: 'icon-pingtai',
    保险订单: 'icon-_baoxiandingdan',
    快钱余额: 'icon-yue',
    签证板块管理: 'icon-guojiaguanli',
    签证国家信息: 'icon-guojiaxinxi',
    签证领区信息: 'icon-dizhi1',
    出行人管理: 'icon-shenqingrenguanli',
    出行人列表: 'icon-liebiao',
    订单中心: 'icon-dingdan',
    签证订单: 'icon-zhuandan',
    签证审核: 'icon-zhuandan',
    机票订单: 'icon-zhuandan',
    机票退票订单: 'icon-zhuandan',
    制签订单: 'icon-zhiqian',
    公证订单: 'icon-gongzheng',
    认证订单: 'icon-mobanguanli',
    交易中心: 'icon-jiaoyizhongxin',
    结算申请: 'icon-gongyingshangfenzhang',
    平台收益: 'icon-qudaodingdan',
    制签对账单: 'icon-xieyitu',
    保险对账单: 'icon-baoxiandingdan',
    同业旅行社: 'icon-lvhangshe',
    悦游收支对账单: 'icon-lvhangshe',
    转单对账单: 'icon-lvhangshe',
    渠道对账单: 'icon-lvhangshe',
    签证员工对账单: 'icon-lvhangshe',
    销售结算审核: 'icon-lvhangshe',
    虚拟卡明细: 'icon-lvhangshe',
    公证认证对账单: 'icon-lvhangshe',
    点券对账单: 'icon-lvhangshe',
    供应商未分账: 'icon-lvhangshe',
    鑫瑞结算单: 'icon-lvhangshe',
    悦游快钱余额: 'icon-lvhangshe',
    财务对账单: 'icon-lvhangshe',
    点券购买数据: 'icon-chongzhi',
    发票管理: 'icon-fapiao',
    运营管理: 'icon-yunying',
    导游管理: 'icon-yunying',
    公告管理: 'icon-gonggao',
    国家提示管理: 'icon-tishi',
    BANNER图管理: 'icon-tupian',
    问答管理: 'icon-wenda',
    百科管理: 'icon-baike',
    公众号菜单: 'icon-liebiao',
    消息中心: 'icon-xiaoxi',
    推送管理: 'icon-tuisongguanli',
    模板管理: 'icon-mobanguanli',
    渠道管理: 'icon-mobanguanli',
    意见反馈: 'icon-fankui',
    菜单面板: 'icon-caidan',
    字典管理: 'icon-zidianguanli',
    操作日志: 'icon-rizhi',
    API审核: 'icon-mobanguanli',
    员工账号管理: 'icon-zhanghaoguanli',
    角色权利管理: 'icon-jiaoseguanli',
    提成配置: 'icon-jiaoseguanli',
    提成配置管理: 'icon-jiaoseguanli',
    采集信息管理: 'icon-fankui',
    行程定制管理: 'icon-dizhi1',
    城市管理: 'icon-qiyeguanli',
    景点管理: 'icon-lvhangshe1',
    酒店管理: 'icon-lvhangshe',
    国家模版: 'icon-zhiqian',
    城市路线: 'icon-dizhi1',
    商城板块管理: 'icon-shangcheng',
    商城品类管理: 'icon-shangcheng-pinleiguanli',
    商城产品管理: 'icon-shangchengchanpin',
    商城订单管理: 'icon-shangchengdingdan',
    旅游管理: 'icon-dingqiguojitonghangchengshishuliang',
    定制订单: 'icon-xctc',
    旅游产品: 'icon-lvyouchanpin',
    旅游订单: 'icon-lvyoudingdan',
    权益卡管理: 'icon-quanyika',
    权益卡兑换列表: 'icon-quanyika',
    权益卡卡密: 'icon-quanyika',
    客服管理: 'icon-shenqingrenguanli',
    客服人员管理: 'icon-shenqingrenguanli',
    聊天记录: 'icon-shenqingrenguanli',
    固定消息配置: 'icon-shenqingrenguanli',
  }
  const menus = await axiosInstance.get('/user/admin/permission/queryByUserNode').then(res => {
    const menuTree = treeUtils.changeChildrenKey(res.data, {
      children: 'childTreeDto',
      newChildren: 'children',
    })

    return treeUtils.map(menuTree, node => {
      return {
        authId: node.nodeId,
        menuType: 'C',
        menuName: node.nodeName,
        menuIcon: titleIconMap[node.nodeName] || '',
        menuUrl: node.nodeIdPath,
      }
    })
  })
  return {
    roles: {
      permissions: {
        menus,
      },
    },
  }
}
